import "./TagSelection.scss"
import {Fragment, useEffect, useState} from "react";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import {css} from "@emotion/css";
import {useParams} from "react-router-dom";
import {MagazineService} from "../../../serverService/magazineService/MagazineService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {useDebounce} from "@uidotdev/usehooks";
import {TagService} from "../../../serverService/tagService/TagService";
import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoSectionContainer,
    showErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components";

import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";

export default function TagSelection() {

    const {id: blogID} = useParams()
    const limit = 5;

    const serviceMagazine = new MagazineService()
    const serviceTag = new TagService()
    const loadingHelper = new LoadingHelper(useLoadingDispatcher())

    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [tagName, setTagName] = useState("");
    const [selectedValues, setSelectedValues] = useState([]);

    const tagNameFilter = useDebounce(tagName, 500)


    useEffect(() => {
        if (typeof serviceMagazine !== 'undefined') {
            loadingHelper.show()
            serviceMagazine.getArticleTags(blogID)
                .then(response => {
                    setSelectedValues(response)
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loadingHelper.hide()
            })
        }
    }, []);

    useEffect(() => {
        if (!open) {
            setOptions([]);
            setLoading(false)
            setTagName("")
        } else {
            getTagsFromServer()
        }
    }, [tagNameFilter, open]);

    function getTagsFromServer() {
        setLoading(true)
        setOptions([])

        serviceTag.getTagOffers(limit, tagNameFilter)
            .then(response => {
                setOptions(response)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setLoading(false)
        })
    }

    function handleUpdateTags() {
        loadingHelper.show()
        serviceMagazine.updateTags(blogID, selectedValues)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loadingHelper.hide()
        })
    }

    return (
        <RaikoBaseCardContainer>
            <RaikoSectionContainer
                title={"مدیریت تگ ها"}
                subTitle={"برای انتخاب تگ جدید نام تگ مورد نظر را وارد نمایید."}
                hasActionButton
                actionButtonOnclick={handleUpdateTags}
            >

                <RaikoGridOneColumn className={css`padding: .5rem 0 0 0`}>
                    <Autocomplete
                        multiple
                        id="tags-outlined"
                        open={open}
                        onOpen={() => {
                            setOpen(true);
                        }}
                        onClose={() => {
                            setOpen(false);
                        }}
                        isOptionEqualToValue={(option, value) => {
                            return option.id === value.id
                        }}
                        getOptionLabel={(option) => option.name}
                        options={options}
                        loading={loading}
                        loadingText={"لطفا صبر کنید"}
                        filterSelectedOptions
                        noOptionsText={"هیچ موردی یافت نشد!"}
                        value={selectedValues}
                        clearText={"حذف همه"}
                        openText={"بازکردن"}
                        closeText={"بستن"}
                        onChange={(event, value) => setSelectedValues(value)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="انتخاب تگ"
                                placeholder="عنوان تگ"
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <Fragment>
                                            {loading ? <CircularProgress color="inherit" size={20}/> : null}
                                            {params.InputProps.endAdornment}
                                        </Fragment>
                                    ),
                                }}
                                value={tagName}
                                onChange={e => {
                                    setTagName(e.target.value)
                                }}
                            />
                        )}
                    />
                    {/* <div className="newTagCreated">
                    <div className="ic_pen"/>
                    <span className="fs-0">ایجاد تگ جدید "{tagName}"</span>
                </div>*/}

                </RaikoGridOneColumn>
            </RaikoSectionContainer>
        </RaikoBaseCardContainer>
    )
}